/// <reference lib="dom" />
import { useState } from 'react';
import {
  Button,
  FloatingLabel,
  FormField,
  InputWithFloatingLabel,
  StandardForm,
  TextInput,
} from '@vp/swan';
import { useInternalViewContext } from '../../hooks/useInternalViewContext';

export const ActiveOrderControl = () => {
  const { internalViewerSuppliedShopperId, setInternalViewShopperId } =
    useInternalViewContext();

  const [shopperIdInput, setShopperIdInput] = useState(
    internalViewerSuppliedShopperId || ''
  );

  const loadShopperOrder = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setInternalViewShopperId(shopperIdInput);
  };

  const onShopperIdEntered = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShopperIdInput(event.currentTarget.value.trim());
  };

  return (
    <StandardForm>
      <FormField>
        <InputWithFloatingLabel>
          <TextInput
            id="shopper-id-entry-internal-view"
            onChange={onShopperIdEntered}
            value={shopperIdInput}
            mb={5}
            aria-required="true"
          />
          <FloatingLabel>Enter a Shopper ID</FloatingLabel>
        </InputWithFloatingLabel>
      </FormField>

      <Button
        skin="primary"
        width="full-width"
        onClick={loadShopperOrder}
        type="submit"
      >
        Submit
      </Button>
    </StandardForm>
  );
};
